import { gql } from "@apollo/client";
import { offeredAnimalGroupFragment } from "trading/api/fragment";

export const groupFragment = gql`
  fragment groupFragment on Group {
    id
    name
    animalsNumberCache
    targetWeight
    animalsToSaleCount
    animalAlertsCount
    businessUnitTarget {
      id
      details
    }
    category
    avgEstimatedWeight
    avgRecordedWeight
    avgDlwg
    targetDate
    daysTillTarget
    summaryMetrics {
      breedrCode
      regBreedCode
      animalsCount
      maleCount
      femaleCount
    }
    animalType {
      id
      image
      colour
      name
    }
  }
`;

export const singleGroupFragment = gql`
  fragment singleGroupFragment on Group {
    id
    name
    animalsNumberCache
    targetWeight
    animals {
      ...offeredAnimalGroupFragment
    }
    weightInfo {
      minWeight
      maxWeight
    }
    minAge
    maxAge
    timeOnFarm
    growthRate
    category
    minDaysOnFarm
    maxDaysOnFarm
    avgEstimatedWeight
    avgRecordedWeight
    avgDlwg
    targetDate
    daysTillTarget
    summaryMetrics {
      breedrCode
      regBreedCode
      animalsCount
      maleCount
      femaleCount
    }
    animalType {
      id
      image
      colour
      name
    }
  }
  ${offeredAnimalGroupFragment}
`;

export const batchProperties = gql`
  fragment batchProperties on Group {
    id
    name
    targetWeight
    category
    targetDate
    numberOfUnidentifiedAnimalsInBatch
    batchDateOnFarm
    animalBreeds {
      id
      name
      breedrCode
    }
    averageDobInBatch
    isBatch
    gendersInBatch
  }
`;
